/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CourseCertificateRelatedViewModel } from "../types/CourseCertificateRelatedViewModel.ts";
import { eTypeCertificateSchema } from "./eTypeCertificateSchema.ts";

export const courseCertificateRelatedViewModelSchema = z.object({
  certificateId: z.optional(
    z.number().int().describe("ID do certificado relacionado ao curso."),
  ),
  certificateDescription: z
    .string()
    .describe("Descrição do certificado.")
    .nullish(),
  typeCertificate: z.optional(
    z
      .lazy(() => eTypeCertificateSchema)
      .describe(
        "0 = MonographAdvise | 1 = MonographBoardMember | 2 = MonographDefense | 3 = FinishCourse | 4 = Teach | 5 = Monitoring | ",
      ),
  ),
  typeCertificateName: z
    .string()
    .describe("Descrição do tipo do certificado (pt-BR).")
    .nullish(),
}) as unknown as ToZod<CourseCertificateRelatedViewModel>;
